module.exports = __webpack_public_path__ + "53370200243c0e8d1de73bba9237e10e.svg";